import {IS_FIELD_INDICATOR, type Document, type Exemplar, type ViewableField, type Volume} from 'src/typings';
import type {LocalizationService} from 'shared/providers';
import type {VolumeDataService} from '../kp-volumes/volume.data-service';
import {exists} from 'shared/utils/custom-utils';
import {getFields, getSubfields, WELL_KNOWN_FIELDS} from 'shared/utils/record-utils';

export class KpDocumentMiniPresenter {
    public static presenterName = 'kpDocumentMiniPresenter';

    /*@ngInject*/
    constructor(private volumeDataService: VolumeDataService, private localizationService: LocalizationService) {
    }

    public hasVolume(exemplar: Exemplar): boolean {
        return exemplar.issue && exists(exemplar.volumeId);
    }

    public async fetchVolumeForExemplar(exemplar: Exemplar): Promise<Volume> {
        return this.volumeDataService.get(exemplar.volumeId.toString());
    }

    public getSeriesText(document: Document): string {
        const getPartPrefix = () => `- ${this.localizationService.get(/* @kp-localization commons.part */ 'commons.part')} `

        return getFields(document, WELL_KNOWN_FIELDS.series.code)
            .filter((field) => field.text.toLowerCase().indexOf(WELL_KNOWN_FIELDS.series.zCykluInfix) !== -1)
            .flatMap((field) => field.fields)
            .filter((subfield) => !IS_FIELD_INDICATOR(subfield))
            .map((subfield) => (subfield.code === WELL_KNOWN_FIELDS.series.g.code ? getPartPrefix() : '') + subfield.text)
            .join(' ');
    }

    public getSf245c(document: Document): ViewableField[] {
        return getSubfields(document, WELL_KNOWN_FIELDS.documentTitle.code, [WELL_KNOWN_FIELDS.documentTitle.responsibilityStatement.code]);
    }

    public getSfAltAuthors(sf245c: ViewableField[], document: Document): ViewableField[] | null {
        if (sf245c.length > 0) {
            return null;
        }
        return [
            ...getSubfields(document, WELL_KNOWN_FIELDS.mainAuthor.code, [WELL_KNOWN_FIELDS.mainAuthor.a.code]),
            ...getSubfields(document, WELL_KNOWN_FIELDS.otherAuthor.code, [WELL_KNOWN_FIELDS.otherAuthor.a.code])
        ];
    }
}